document.addEventListener('DOMContentLoaded', function () {
  const teaserSelector = '.kl-teaser-UxE3ZE';
  const productSelector = '.jw-section.jw-main-product';

  function initObserver(productSection, teaser) {
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        const isVisible = entry.isIntersecting;
        if (isVisible) {
          teaser.style.display = 'none';
        } else {
          teaser.style.display = 'block';
        }
      },
      {
        root: null,
        threshold: 0.1,
      }
    );

    observer.observe(productSection);
  }

  function waitForElements() {
    const productSection = document.querySelector(productSelector);
    const teaser = document.querySelector(teaserSelector);

    if (productSection && teaser) {
      initObserver(productSection, teaser);
      return;
    }

    const observer = new MutationObserver(() => {
      const productNow = document.querySelector(productSelector);
      const teaserNow = document.querySelector(teaserSelector);
      if (productNow && teaserNow) {
        observer.disconnect();
        initObserver(productNow, teaserNow);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  waitForElements();
});
